import * as React from "react";
import { api } from "@repo/convex/convex/_generated/api";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { usePaginatedItems } from "../common/hooks.ts";
import { PageHeader } from "../common/PageHeader.tsx";
import { ItemsScrollArea } from "../common/items/ItemsScrollArea.tsx";
import { ArchiveItem } from "./ArchiveItem.tsx";
import { ArchivedItemDoc } from "@repo/convex/convex/schema.ts";
import { ListedItem } from "@repo/convex/convex/items.ts";

interface Props {}

export const ArchivePage: React.FC<Props> = ({}) => {
  const { status, loadMore, isLoading, items } = usePaginatedItems({
    statusKind: "archived",
  });
  const count = useQuery(api.items.count, { statusKind: "archived" });

  return (
    <>
      <PageHeader title="Archive" subtitle={readCount(count)} />
      <ItemsScrollArea
        items={items}
        isLoading={isLoading}
        empty={{
          title: "Nothing tucked in yet",
          detail: "Finish something, then archive it with your notes so you can find it again.",
        }}
        renderItem={(item) => (
          <ArchiveItem key={item._id} item={item as ListedItem<ArchivedItemDoc>} />
        )}
        onLoadMore={() => loadMore(20)}
        canLoadMore={status == "CanLoadMore"}
      />
    </>
  );
};

const readCount = (count: number | undefined) => {
  if (count === undefined) return "\u00a0";
  if (count == 0) return "nothing in the book yet";
  if (count == 1) return "1 thing I actually read";
  return `${count >= 500 ? "500+" : count} things I actually read`;
};
